import React, { useState, useRef, useEffect } from 'react';
import {
  Button,
  Grid,
  Column,
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  Modal,
  TextInput,
  RadioButtonGroup,
  RadioButton,
  Row,
  Select,
  SelectItem,
  Theme,
  FileUploader
} from '@carbon/react';
import {
  getDocument,
  postSupplierAttachment,
  getListInvoiceAttachments } from '../../services/services';
import { useNavigate } from "react-router-dom";
import CommodityHeader from '../../components/Header';
import SessionController from '../../components/FrontSessionController/SessionController';
import MessageModal from "../../components/MessageModal/MessageModal";


const headers = [
  {
    key: 'ctrycode',
    header: 'Country',
  },
  {
    key: 'formtype',
    header: 'Form Type',
  },
  {
    key: 'status',
    header: 'Status',
  },
  {
    key: 'role',
    header: 'Role',
  },
  {
    key: 'nextapprover',
    header: 'Next Approver',
  },
  {
    key: 'invonumb',
    header: 'Internal Reference',
  },
  {
    key: 'compcode',
    header: 'Company',
  },
  {
    key: 'supplierName',
    header: 'Supplier Name',
  },
  {
    key: 'supplierNumber',
    header: 'Supplier Number',
  },
  {
    key: 'runExp',
    header: 'Run Exp',
  },
];

const AttachmentsAdmin = () => {
  const [searchModal, setSearchModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [replaceModal, setReplaceModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [rows, setRows] = useState([]);
  const [inputGetDoc, setInputGetDoc] = useState();
  const [searchByType, setSearchByType] = useState();
  const [supplierAttachments, setSupplierAttachments] = useState([]);
  const [userSesion, setuser] = useState();
  const [indexFromFileChosen, setIndexFromFileChosen] = useState();
  const [newFileInfo, setNewFileInfo] = useState();
  const [disableSubmitAddBtt, setDisableSubmitAddBtt] = useState(true);
  const [disableSubmitDeleteBtt, setDisableSubmitDeleteBtt] = useState(true);

  const [replaceAttachmentHasBeenAdded, setReplaceAttachmentHasBeenAdded] = useState(false);
  const [attachmentToReplaceHasBeenSelected,setAttachmentToReplaceHasBeenSelected] = useState(false);
  const [disableSubmitReplaceBtt, setDisableSubmitReplaceBtt] = useState(true);


  const [messageModal, setMessageModal] = useState('');
  const [messageSessionLost, setMessageSessionLost] = useState('');
  const [supplierAttachmentToSave,setSupplierAttachmentToSave] = useState({});
  
  const currentIddoc = useRef();
  const currentDocument = useRef();
  const messageResponse = useRef([]); 
  const processingRequest = useRef(false);
  const requestAction = useRef('');
  const myAddFileUploadRefference = useRef();
  const myReplaceFileUploadRefference = useRef();
  const navigate = useNavigate();

  const openSearchModal = () => {
    setSearchModal(true);
  };
  const closeSearchModal = () => {
    setSearchModal(false);
  };
  const openDeleteModal = () => {
    setDeleteModal(true);
  };
  const closeDeleteModal = () => {
    setDeleteModal(false);
  };
  const openReplaceModal = () => {
    setNewFileInfo(undefined);
    setReplaceModal(true);
  };
  const closeReplaceModal = () => {
    myReplaceFileUploadRefference.current.clearFiles();
    setReplaceModal(false);
  };
  const openAddModal = () => {
    setNewFileInfo(undefined);
    setAddModal(true);
  };
  const closeAddModal = () => {
    myAddFileUploadRefference.current.clearFiles();
    removeSupplierAddAttachment();
    setAddModal(false);
  };

  const openMessageModal = (response) => {    
    let newMessageResponse = [messageResponse.current,<br/>,<br/>,response];    
    messageResponse.current = newMessageResponse;
    setMessageModal(true);
  }
    
 

  const parserResponseGetDoc = (res) => {
    setRows([
      {
        id: "" + res.idDoc,
        ctrycode: "" + res.ctrycode,
        formtype: "" + res.flowType,
        status: "" + res.docStatus,
        role: "" + res.nextApproverRol,
        nextapprover: "" + res.nextApproverName,
        invonumb: "" + res.invonumb,
        compcode: "" + res.compcode,
        supplierName: "" + res.supplierName,
        supplierNumber: "" + res.suppnumb,
        runExp: "" + res.runExport,

      }
    ]);
    currentDocument.current = res;
    currentIddoc.current = res.idDoc;    
  };

  const closeMessageModal = () => {
    setMessageModal(false);    
    messageResponse.current = [];
  }

  const processGetDoc = (type) => {
    if (type === "invonumb") {
      setSearchByType("invonumb");
    } else if (type === "invoice") {
      setSearchByType("nrofac");
    }
  };

  const processInputForGetDoc = (e) => {
    const type = e.target.id;
    if (type.includes("input-getDoc")) {
      setInputGetDoc(e.target.value);
    }
  };

 

  const submitSearchDoc = async () => {
    let searchType = searchByType;
    if (searchType === undefined) {      
      searchType = "invonumb";
    }

    let jsonRequest = {};
    jsonRequest.keyType = searchType;
    jsonRequest.key = inputGetDoc;
    
    getDocumentForTable(jsonRequest);    
    closeSearchModal();    
  };

  const isRequestActive = (enable) => {
    if(enable){
      if(processingRequest.current){
        openMessageModal('The request is processing');
        return true;
      }
      document.body.className = 'waiting';
      processingRequest.current = enable;      
      return false;
    }else{
      processingRequest.current = enable;
      document.body.className = '';
    }
    return false;
  }

  const getDocumentForTable = async (request) => {
    if(isRequestActive(true)){
      return;
    } 
    await getDocument(request)
    .then(response => {
      if(response.status === 200){
        response.json()
          .then(response => {
            
            parserResponseGetDoc(response);
            getAttachmentList(response.idDoc);
          })
      } else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }else{
        response.text()
          .then(res => {
            openMessageModal(res)                             
          })
      }
    });    
    isRequestActive(false);
  }

  const getAttachmentList = (idDoc) => {
    let jsonRequest = {};
    jsonRequest.idDoc = idDoc;
    getListInvoiceAttachments(jsonRequest)
    .then(response => {
      if(response.status === 200){
        response.json()
          .then(response => {            
            
            setSupplierAttachments(response.supplierAttachments);                                                      
          })
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } else{
        response.text()
          .then(response => {
            openMessageModal(response);
          })
      }
    });        
  }


  const submitRequestAttachment = (formData) => {            
    if(isRequestActive(true)){
      return;
    }
    postSupplierAttachment(formData)
    .then(response => {
      if(response.status === 200){
        myAddFileUploadRefference.current.clearFiles();
        setSupplierAttachmentToSave({})
        getAttachmentList(currentIddoc.current);
        openMessageModal("Request Successful");
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } else{
        response.text()
        .then(response => {
          openMessageModal(response);
        })
      }
      isRequestActive(false)
    });
  }

  const submitAddFile = () => {
    if(supplierAttachmentToSave.name === undefined){
      return;
    }    
    let formData = getGenericFormData(supplierAttachmentToSave);
    submitRequestAttachment(formData);
    closeAddModal();
  }

  const submitReplaceAttachment = () => {
    if(supplierAttachmentToSave.name === undefined){
      return;
    }    
    let formData = getGenericFormData(supplierAttachmentToSave);
    formData.append('action','replace');
    formData.append('index', indexFromFileChosen);
    submitRequestAttachment(formData);
    closeReplaceModal();
  }

  const submitDeleteFile = () => {
    let formData = getGenericFormData(supplierAttachmentToSave);
    formData.append('action', 'delete');
    formData.append('index',indexFromFileChosen);
    submitRequestAttachment(formData);
    closeDeleteModal();
    setDisableSubmitDeleteBtt(true);
  }

  const getGenericFormData = (attachmentToSave) => {
    let formData = new FormData();
    formData.append('idDoc',currentIddoc.current);
    formData.append('pais',currentDocument.current.ctrycode);
    formData.append('compania',currentDocument.current.compcode);
    formData.append('invonumb',currentDocument.current.invonumb);        
    formData.append("file",attachmentToSave);
    return formData;
  }

  const processAddSupplierAttachment = (input) => {
    setDisableSubmitAddBtt(true);
    try{
      addAttachmentForSubmit(input);
    }catch(e){
      console.log(e)
      return;
    }
    setDisableSubmitAddBtt(false)    
  }

  const processReplaceSupplierAttachment = (input) => {
    setReplaceAttachmentHasBeenAdded(false);
    try{
      addAttachmentForSubmit(input);
    }catch(e){
      console.log(e)
      return;
    }
    setReplaceAttachmentHasBeenAdded(true);
  }

  const processFileSelectedForReplace = (index) => {
    setAttachmentToReplaceHasBeenSelected(false);
    if(index === ""){
      return;
    }
    setIndexFromFileChosen(index)
    setAttachmentToReplaceHasBeenSelected(true);
  }

  const addAttachmentForSubmit = (input) => {
    let files = input.target.files;
    let fileFound = false;
    if(files[0] != undefined){
      fileFound = true;
    }
    if(!fileFound){
      throw new Error("File not found");
    }
    setSupplierAttachmentToSave(files[0]);
  }

  const removeSupplierAddAttachment = () => {
    setDisableSubmitAddBtt(true);
    setSupplierAttachmentToSave({})
  }
  
  const removeSupplierReplaceAttachment = () => {
    setReplaceAttachmentHasBeenAdded(false);
    setSupplierAttachmentToSave({})
  }

  const getAttachmentName = (pathname) => {
    let filename = pathname;
    let pathNameSplit = pathname.split("=")[1];
    if(pathNameSplit !== undefined){
      filename = pathNameSplit;
    }
    return filename
  }

  const processFileSelectedForDelete = (fileIndexSelected) => {
    setDisableSubmitDeleteBtt(true);
    if(fileIndexSelected === ''){
      return;
    }
    setIndexFromFileChosen(fileIndexSelected);
    setDisableSubmitDeleteBtt(false);
  }

  const goHomeScreen = () => {
    navigate("/home");
  };

  useEffect(() => {
    setDisableSubmitReplaceBtt(!(replaceAttachmentHasBeenAdded && attachmentToReplaceHasBeenSelected));
  },[replaceAttachmentHasBeenAdded, attachmentToReplaceHasBeenSelected])

  return (
    <>
      <Theme theme="g90">
        <CommodityHeader />
      </Theme>
      <h2 className="table-title">Attachments Administration</h2>
      <Grid>
        <Column lg={16} >
          <DataTable
            rows={rows}
            headers={headers}
            render={({
              rows,
              headers,
              getHeaderProps,
              getRowProps,
              getTableProps
            }) => (
              <TableContainer>
                <Button className="style-bttSearchDocument" size="md" onClick={goHomeScreen}>Back to Home</Button>
                <Button className="style-bttSearchDocument" onClick={openSearchModal} size="md">Search Document</Button>
                <Button className="style-bttDeleteAttachment" onClick={openDeleteModal} size="md">Delete Attachment</Button>
                <Button className="style-bttReplaceAttachment" onClick={openReplaceModal} size="md">Replace Attachment</Button>
                <Button className="style-bttAddAttachment" onClick={openAddModal} size="md">Add Attachment</Button>
                <Table {...getTableProps()} useZebraStyles>
                  <TableHead>
                    <TableRow>
                      {headers.map(header => (
                        <TableHeader {...getHeaderProps({ header })}>
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map(row => (
                      <TableRow {...getRowProps({ row })}>
                        {row.cells.map(cell => (
                          <TableCell key={cell.id}>{cell.value}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          />
        </Column>
      </Grid>
      <Modal
        className="search-document-modal"
        focusTrap={false}
        hasscrollingcontent="false"
        iconDescription="Close the modal"
        aria-label="Search Document"
        modalAriaLabel="Search Document"
        onBlur={function noRefCheck() { }}
        onClick={function noRefCheck() { }}
        onFocus={function noRefCheck() { }}
        onKeyDown={function noRefCheck() { }}
        onRequestClose={closeSearchModal}
        onRequestSubmit={() => submitSearchDoc()}
        onSecondarySubmit={closeSearchModal}
        open={searchModal}
        passiveModal={false}
        primaryButtonDisabled={false}
        primaryButtonText="Submit"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        modalLabel={<p><strong>Search Document</strong></p>}
        size="md"
      >
        <Grid className="column-getDoc">
          <Column lg={16}>
            <Row className={"text-test"}>
              <RadioButtonGroup legendText={<p><strong>Search By:</strong></p>} 
                name="select-radio-button" defaultSelected="radio-1">
                <RadioButton labelText="Internal Reference" onClick={() => processGetDoc("invonumb")} 
                  value="radio-1" id="radio-1" />
                <RadioButton labelText="Invoice Number" onClick={() => processGetDoc("invoice")} 
                  value="radio-2" id="radio-2" />
              </RadioButtonGroup>
              <TextInput className="" onChange={(e) => processInputForGetDoc(e)} 
                style={{marginTop:'30px'}}
                id="text-input-getDoc" type="text" placeholder="" size="lg" />
            </Row>
          </Column>
        </Grid>
      </Modal>
      <Modal
        className="delete-document-modal"
        focusTrap={false}
        hasscrollingcontent="false"
        iconDescription="Close the modal"
        aria-label="Delete Document"
        modalAriaLabel="Delete Document"
        onBlur={function noRefCheck() { }}
        onClick={function noRefCheck() { }}
        onFocus={function noRefCheck() { }}
        onKeyDown={function noRefCheck() { }}
        onRequestClose={closeDeleteModal}
        onRequestSubmit={() => submitDeleteFile()}
        onSecondarySubmit={closeDeleteModal}
        open={deleteModal}
        passiveModal={false}
        primaryButtonDisabled={disableSubmitDeleteBtt}
        primaryButtonText="Submit"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        modalLabel={<p><strong>Delete Document</strong></p>}
        size="md"
      >
        <Grid className="column-getDoc">
          <Column lg={16}>
            <Select className="style-select-delegation"
              defaultValue={""}
              id="selectJustif"
              onChange={(e) => processFileSelectedForDelete(e.target.value)}
            >
              <SelectItem key={0} text={"Select one"} value={""}></SelectItem>
              {
                supplierAttachments.map((file) => (
                  <>
                    <SelectItem key={file.key.index} text={getAttachmentName(file.pathname)} value={file.key.index}></SelectItem>
                  </>
                ))
              }
            </Select>
          </Column>
        </Grid>
      </Modal>
      <Modal
        className="replace-document-modal"
        focusTrap={false}
        hasscrollingcontent="false"
        iconDescription="Close the modal"
        aria-label="Replace Document"
        modalAriaLabel="Replace Document"
        onBlur={function noRefCheck() { }}
        onClick={function noRefCheck() { }}
        onFocus={function noRefCheck() { }}
        onKeyDown={function noRefCheck() { }}
        onRequestClose={closeReplaceModal}
        onRequestSubmit={() => submitReplaceAttachment()}
        onSecondarySubmit={closeReplaceModal}
        open={replaceModal}
        passiveModal={false}
        primaryButtonDisabled={disableSubmitReplaceBtt}
        primaryButtonText="Submit"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        modalLabel={<p><strong>Replace Document</strong></p>}
        size="md"
      >
        <Grid className="column-getDoc">
          <Column lg={8} >
            <Row className={"text-test"}>
              <FileUploader labelTitle=""     
                ref={fileUploaderRefference => (myReplaceFileUploadRefference.current = fileUploaderRefference)}
                buttonLabel="Search attachment" buttonKind="primary" size="lg" 
                filenameStatus="edit" multiple={false} 
                disabled={false}                
                onChange={(e) => {processReplaceSupplierAttachment(e)}} 
                onDelete={() => removeSupplierReplaceAttachment()}
                iconDescription="Add file" name="" />                                     
            </Row>
            <Row className={"text-test"}>
            <Select 
                defaultValue={""}
                labelText="Select the file to replace:"
                id="selectFileReplace"
                onChange={(e) => processFileSelectedForReplace(e.target.value)}
              >
                <SelectItem key={0} text={"Select one"} value={""}></SelectItem>
                {
                  supplierAttachments.map((file) => (
                    <>
                      <SelectItem key={file.key.index} text={getAttachmentName(file.pathname)} value={file.key.index}></SelectItem>
                    </>
                  ))
                }

              </Select>
            </Row>            
          </Column>

        </Grid>
      </Modal>
      <Modal
        className="add-document-modal"
        focusTrap={false}
        hasscrollingcontent="false"
        iconDescription="Close the modal"
        aria-label="Add Document"
        modalAriaLabel="Add Document"
        onBlur={function noRefCheck() { }}
        onClick={function noRefCheck() { }}
        onFocus={function noRefCheck() { }}
        onKeyDown={function noRefCheck() { }}
        onRequestClose={closeAddModal}
        onRequestSubmit={() => submitAddFile()}
        onSecondarySubmit={closeAddModal}
        open={addModal}
        passiveModal={false}
        primaryButtonDisabled={disableSubmitAddBtt}
        primaryButtonText="Submit"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        modalLabel={<p><strong>Add Document</strong></p>}
        size="md"
      >
        <Grid className="column-getDoc">
          <Column lg={16}>
            <Row>
            <FileUploader labelTitle=""     
                ref={fileUploaderRefference => (myAddFileUploadRefference.current = fileUploaderRefference)}
                buttonLabel="Search attachment" buttonKind="primary" size="lg" 
                filenameStatus="edit" multiple={false} 
                disabled={false}                
                onChange={(e) => {processAddSupplierAttachment(e)}} 
                onDelete={() => removeSupplierAddAttachment()}
                iconDescription="Add file" name="" />                   
            </Row>
            
          </Column>
        </Grid>
      </Modal>
      <MessageModal messageCallback={messageResponse.current} messageModalCallback={messageModal} closeMessageModalCallback={closeMessageModal}/>
      <SessionController messageLostSessionCallback={messageSessionLost} />
    </>
  );
};

export default AttachmentsAdmin;